import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardExperienciaProyectos from "components/Varios/CardExperienciaProyectos.js";

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { MensajeEncabezadoContactoDecanatoInvestigacion } from './PublicacionesRealizadas';

const id = 1043;
const API_URL = configData.SERVER_URL

export class ExperienciaProyectosData {
    idproyectoinvestigacion: number = 0;
    idpersona: number = 0;
    idpais: number = 0;
    idrolproyecto: number = 0;

    tipo: string = "";
    subtipo: string = "";
    nombre: string = "";
    institucionExterna: string = "";
    institucionEspol: string = "";
    estadoproyecto: string = "";
    fechafin: string = "";
    fechainicio: string = "";
    responsfinanc: string = "";
    tabla: string = "";

    idnomenclaturatit: number = 0;
    idareaconocim: number = 0;
    idsubareaconoc: number = 0;

    idareafrascati: number = 0;
    idsubareafrascati: number = 0;

    strCampoamplio: string = "";
    strCampodetallado: string = "";
    strCampoespecifico: string = "";

    idnomenclaturatit2: number = 0;
    idareaconocim2: number = 0;
    idsubareaconoc2: number = 0;

    idareafrascati2: number = 0;
    idsubareafrascati2: number = 0;

    strCampoamplio2: string = "";
    strCampodetallado2: string = "";
    strCampoespecifico2: string = "";

    refarchivo1: string = "";
    refarchivo2: string = "";
    refarchivo3: string = "";
}


interface ExperienciaProyectosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: ExperienciaProyectosData;
    paisList: Array<any>;
    tipoProyectoList: Array<any>;
    subtipoProyectoList: Array<any>;
    rolList: Array<any>;
    areaCINEList: Array<any>;
    subAreaCINEList: Array<any>;
    materiaCINEList: Array<any>;
    areaFrascatiList: Array<any>;
    subAreaFrascatiList: Array<any>;

    areaCINEList2: Array<any>;
    subAreaCINEList2: Array<any>;
    materiaCINEList2: Array<any>;
    areaFrascatiList2: Array<any>;
    subAreaFrascatiList2: Array<any>;

    ExperienciaProyectosDataList: ExperienciaProyectosData[];
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class ExperienciaProyectos extends React.Component<RouteComponentProps<{}>, ExperienciaProyectosDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new ExperienciaProyectosData(),
            tipoProyectoList: [], subtipoProyectoList: [], rolList: [], areaCINEList: [], subAreaCINEList: [], materiaCINEList: [],
            areaFrascatiList: [], subAreaFrascatiList: [], areaCINEList2: [], subAreaCINEList2: [], materiaCINEList2: [],
            areaFrascatiList2: [], subAreaFrascatiList2: [], ExperienciaProyectosDataList: [], paisList: [], error: null,
            tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarExperienciaProyectos = this.cargarExperienciaProyectos.bind(this);
        this.cargarSubtipos = this.cargarSubtipos.bind(this);
        this.cargarSubAreaCINE = this.cargarSubAreaCINE.bind(this);
        this.cargarMaterias = this.cargarMaterias.bind(this);
        this.cargarSubAreaFrascati = this.cargarSubAreaFrascati.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarExperienciaProyectos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPOS DE PROYECTO
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO PROYECTO")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoProyectoList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoProyectoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER ROLES
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/ROL PROYECTO")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            rolList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        rolList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS DE CONOCMIENTO CINE
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoAmplio/0/0/0/00")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            areaCINEList: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                            areaCINEList2: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas de conocimiento CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        areaCINEList: [],
                        areaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS FRASCATI
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/" + "AREA FRASCATI")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            areaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                            areaFrascatiList2: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las áreas FRASCATI.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        areaFrascatiList: [],
                        areaFrascatiList2: [],
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER PROYECTOS DE PERSONA
    cargarExperienciaProyectos() {
        fetch(API_URL + "DatosEscalafon/ProyectosDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            ExperienciaProyectosDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(null)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los ExperienciaProyectos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        ExperienciaProyectosDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER SUBTITPOS
    cargarSubtipos(subtipo) {
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/SUBTIPO PROYECTO " + subtipo)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            subtipoProyectoList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subtipoProyectoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaFrascati(idcatalogopadre, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["idareafrascati" + tipo] = idcatalogopadre;
        if (change) {
            dto['idsubareafrascati' + tipo] = 0;
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogoSubAreaFrascatiByCodigo/" + idcatalogopadre)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (tipo == "") {
                            this.setState({
                                subAreaFrascatiList: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        }
                        else {
                            this.setState({
                                subAreaFrascatiList2: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas FRASCATI.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subAreaFrascatiList: [],
                        subAreaFrascatiList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaCINE(strCampoamplio, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["strCampoamplio" + tipo] = strCampoamplio;
        if (change) {
            dto['strCampoespecifico' + tipo] = "";
            dto['strCampodetallado' + tipo] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoEspecifico/0/0/00/" + strCampoamplio)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (tipo === "") {
                            this.setState({
                                subAreaCINEList: result.entTabla.map(d => ({
                                    "value": d.campoespecifico,
                                    "label": d.nombrecampoe
                                })),
                            });
                        }
                        else {
                            this.setState({
                                subAreaCINEList2: result.entTabla.map(d => ({
                                    "value": d.campoespecifico,
                                    "label": d.nombrecampoe
                                })),
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las subáreas CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subAreaCINEList: [],
                        subAreaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarMaterias(strCampoespecifico, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["strCampoespecifico" + tipo] = strCampoespecifico;
        if (change) {
            dto['strCampodetallado' + tipo] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoDetallado/0/00/" + dto.strCampoamplio + "/" + strCampoespecifico)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        if (tipo === "") {
                            this.setState({
                                materiaCINEList: result.entTabla.map(d => ({
                                    "value": d.idnomenclaturatit,
                                    "label": d.nombrecampod
                                })),
                            });
                        }
                        else {
                            this.setState({
                                materiaCINEList2: result.entTabla.map(d => ({
                                    "value": d.idnomenclaturatit,
                                    "label": d.nombrecampod
                                })),
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las materias CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        materiaCINEList: [],
                        materiaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }



    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "idnomenclaturatit") {
            dto["strcampodetallado"] = value;
        }

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(tipoEvidencia) {
        var tiposEvidencia = [{ "value": "PRO", "label": "Evidencia de proyecto" }];
        //console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: ExperienciaProyectosData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo1) {
            evidencias.push({ name: "PRO-1" + infoAcademica.idpersona + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoProyecto/" + infoAcademica.tabla + "/1/" + infoAcademica.idproyectoinvestigacion + "/" + infoAcademica.idpersona });
        }
        if (infoAcademica.refarchivo2) {
            evidencias.push({ name: "PRO-2" + infoAcademica.idpersona + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoProyecto/" + infoAcademica.tabla + "/2/" + infoAcademica.idproyectoinvestigacion + "/" + infoAcademica.idpersona });
        }
        if (infoAcademica.refarchivo3) {
            evidencias.push({ name: "PRO-3" + infoAcademica.idpersona + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoProyecto" + infoAcademica.tabla + "/3/" + infoAcademica.idproyectoinvestigacion + "/" + infoAcademica.idpersona });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new ExperienciaProyectosData() });
    }

    onClickEdit(tabla, idproyectoinvestigacion, idpersona) {
        this.setState({
            dtoData: new ExperienciaProyectosData()
        });

        fetch(API_URL + "DatosEscalafon/ProyectosById/" + tabla + "/" + idproyectoinvestigacion + "/" + idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(null),
                            loading: false
                        });

                        if (result.entTabla[0]["tipo"] == 'I') {
                            this.cargarSubtipos('INVESTIGACION')
                        }
                        else if (result.entTabla[0]["tipo"] == 'V') {
                            this.cargarSubtipos('VINCULACION')
                        }
                        else {
                            this.setState({
                                subtipoProyectoList: []
                            });
                        }

                        if (result.entTabla[0]["strCampoamplio"]) {
                            this.cargarSubAreaCINE(result.entTabla[0]["strCampoamplio"], false, "")
                        }

                        if (result.entTabla[0]["strCampoespecifico"]) {
                            this.cargarMaterias(result.entTabla[0]["strCampoespecifico"], false, "")
                        }

                        if (result.entTabla[0]["idareafrascati"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati"], false, "")
                        }

                        if (result.entTabla[0]["strCampoamplio2"]) {
                            this.cargarSubAreaCINE(result.entTabla[0]["strCampoamplio2"], false, "2")
                        }

                        if (result.entTabla[0]["strCampoespecifico2"]) {
                            this.cargarMaterias(result.entTabla[0]["strCampoespecifico2"], false, "2")
                        }

                        if (result.entTabla[0]["idareafrascati2"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati2"], false, "2")
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        dtoData: new ExperienciaProyectosData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idproyectoinvestigacion) {
        fetch(API_URL + "FormularioController/DeleteDatosIdiomaPersona/" + idproyectoinvestigacion, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El idioma se eliminó correctamente.")
                        this.cargarExperienciaProyectos();
                    }
                })
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idproyectoinvestigacion === 0) {
                fetch(API_URL + "FormularioController/PostDatosIdiomaPersona", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            //console.log(responseJson)
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El idioma se ha registrado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idproyectoinvestigacion', responseJson.entidad.idproyectoinvestigacion);

                                    fetch(API_URL + "FormularioController/PostFilesDatosExperienciaProyectos", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error) //console.log(error)
                                        );
                                }
                                this.cargarExperienciaProyectos();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosIdiomaPersona", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El idioma se ha actualizado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('idproyectoinvestigacion', responseJson.entidad.idproyectoinvestigacion);

                                    fetch(API_URL + "FormularioController/PostFilesDatosExperienciaProyectos", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(success => {
                                            // Do something with the successful response
                                        })
                                        .catch(error => alertService.error(error) //console.log(error)
                                        );
                                }
                                this.onClickLimpiar();
                                this.cargarExperienciaProyectos();

                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )


            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.ExperienciaProyectosDataList, this.state.paisList, this.state.tipoProyectoList,
                this.state.subtipoProyectoList, this.state.rolList, this.state.areaCINEList, this.state.subAreaCINEList,
                this.state.materiaCINEList, this.state.areaFrascatiList, this.state.subAreaFrascatiList, this.state.areaCINEList,
                this.state.subAreaCINEList2, this.state.materiaCINEList2, this.state.areaFrascatiList2, this.state.subAreaFrascatiList2,
                this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(ExperienciaProyectosDataList: Array<any>, paisList: Array<any>, tipoProyectoList: Array<any>,
        subtipoProyectoList: Array<any>, rolList: Array<any>, areaCINEList: Array<any>, subAreaCINEList: Array<any>,
        materiaCINEList: Array<any>, areaFrascatiList: Array<any>, subAreaFrascatiList: Array<any>, areaCINEList2: Array<any>,
        subAreaCINEList2: Array<any>, materiaCINEList2: Array<any>, areaFrascatiList2: Array<any>, subAreaFrascatiList2: Array<any>,
        tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Experiencia en proyectos</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    { MensajeEncabezadoContactoDecanatoInvestigacion }
                                    {
                                        //<form onSubmit={this.handleSave}>
                                        //    <Row form>
                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                <Label for="tipo">Tipo de proyecto</Label>
                                        //                <SelectItem
                                        //                    options={tipoProyectoList}
                                        //                    value={this.state.dtoData.tipo}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="tipo"
                                        //                    id="tipo"
                                        //                    icon="fa-caret-right"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                <Label for="ididioma">Tipo de investigación</Label>
                                        //                <SelectItem
                                        //                    options={subtipoProyectoList}
                                        //                    value={this.state.dtoData.subtipo}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="ididioma"
                                        //                    id="ididioma"
                                        //                    icon="fa-caret-right"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={6}>
                                        //            <FormGroup>
                                        //                <Label for="nombre">Nombre del proyecto</Label>
                                        //                <Input name="nombre" id="nombre" value={this.state.dtoData.nombre} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={4}>
                                        //            <FormGroup>
                                        //                <Label for="institucion">Institución</Label>
                                        //                <Input name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={2}>
                                        //            <Label for="fechainicio">Desde</Label>
                                        //            <Datepicker
                                        //                value={this.state.dtoData.fechainicio}
                                        //                name="fechainicio"
                                        //                id="fechainicio"
                                        //                onChange={this.handleSelectChange}
                                        //                disabled={true}
                                        //            />
                                        //        </Col>
                                        //        <Col md={2}>
                                        //            <Label for="fechafin">Hasta</Label>
                                        //            <Datepicker
                                        //                value={this.state.dtoData.fechafin}
                                        //                name="fechafin"
                                        //                id="fechafin"
                                        //                onChange={this.handleSelectChange}
                                        //                disabled={true}
                                        //            />
                                        //        </Col>
                                        //        <Col md={4}>
                                        //            <FormGroup>
                                        //                <Label for="idpais">País</Label>
                                        //                <SelectItem
                                        //                    options={paisList}
                                        //                    value={this.state.dtoData.idpais}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="idpais"
                                        //                    id="idpais"
                                        //                    icon="pais"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                <Label for="responsfinanc">Financiado por</Label>
                                        //                <Input name="responsfinanc" id="responsfinanc" value={this.state.dtoData.responsfinanc} onChange={this.handleChange} required readOnly />
                                        //            </FormGroup>
                                        //        </Col>
                                        //        <Col md={3}>
                                        //            <FormGroup>
                                        //                <Label for="idrolproyecto">Rol del proyecto</Label>
                                        //                <SelectItem
                                        //                    options={rolList}
                                        //                    value={this.state.dtoData.idrolproyecto}
                                        //                    onChange={this.handleSelectChange}
                                        //                    placeholder=""
                                        //                    name="idrolproyecto"
                                        //                    id="idrolproyecto"
                                        //                    icon="fa-caret-right"
                                        //                    disabled={true}
                                        //                />
                                        //            </FormGroup>
                                        //        </Col>

                                        //        {this.descargarEvidencias(this.state.dtoData).length > 0 ?
                                        //            <Col md={3}>
                                        //                <Label for="fechagraduacion">Evidencia</Label>
                                        //                <FormGroup row>
                                        //                    {
                                        //                        //<Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 9 : 12)}>
                                        //                        //    <InputFileUpload
                                        //                        //        icon="upload"
                                        //                        //        onChange={this.handleFileUploadChange}
                                        //                        //        name="PRO"
                                        //                        //        placeholder={this.state.dtoData.refarchivo1 ? "Actualizar evidencia" : "Subir evidencia"} />
                                        //                        //</Col>
                                        //                    }

                                        //                    <FileDownload files={this.descargarEvidencias(this.state.dtoData)} icon="download" />
                                        //                </FormGroup>
                                        //            </Col>
                                        //            :
                                        //            null
                                        //        }



                                        //    </Row>

                                        //    <Row form>
                                        //        <Col md={6}>
                                        //            <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO CINE</p>
                                        //            <FormGroup row>
                                        //                <Col md={4} className="">
                                        //                    <Label for="idpais">Área de conocimiento <br /> CINE en función del título</Label>
                                        //                    <SelectItem
                                        //                        options={areaCINEList}
                                        //                        value={this.state.dtoData.strCampoamplio}
                                        //                        onChange={this.cargarSubAreaCINE}
                                        //                        placeholder=""
                                        //                        name="strCampoamplio"
                                        //                        id="strCampoamplio"
                                        //                        icon="fa-caret-right"
                                        //                        tipo=""
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={4} className="">
                                        //                    <Label for="strCampoespecifico">Sub-Área de  <br /> conocimiento CINE</Label>
                                        //                    <SelectItem
                                        //                        options={subAreaCINEList}
                                        //                        value={this.state.dtoData.strCampoespecifico}
                                        //                        onChange={this.cargarMaterias}
                                        //                        placeholder=""
                                        //                        name="strCampoespecifico"
                                        //                        id="strCampoespecifico"
                                        //                        icon="fa-caret-right"
                                        //                        tipo=""
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={4} className="">
                                        //                    <Label for="strCampodetallado">Área de conocimiento <br /> (materias)</Label>
                                        //                    <SelectItem
                                        //                        options={materiaCINEList}
                                        //                        value={this.state.dtoData.idnomenclaturatit}
                                        //                        onChange={this.handleSelectChange}
                                        //                        placeholder=""
                                        //                        name="idnomenclaturatit"
                                        //                        id="strCampodetallado"
                                        //                        icon="fa-caret-right"
                                        //                        tipo=""
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //            </FormGroup>

                                        //        </Col>

                                        //        <Col md={6}>
                                        //            <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO FRASCATI</p>
                                        //            <FormGroup row>
                                        //                <Col md={6} className="">
                                        //                    <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título</Label>
                                        //                    <SelectItem
                                        //                        options={areaFrascatiList}
                                        //                        value={this.state.dtoData.idareafrascati}
                                        //                        onChange={this.cargarSubAreaFrascati}
                                        //                        placeholder=""
                                        //                        name="idareafrascati"
                                        //                        id="idareafrascati"
                                        //                        icon="fa-caret-right"
                                        //                        tipo=""
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={6} className="">
                                        //                    <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI</Label>
                                        //                    <SelectItem
                                        //                        options={subAreaFrascatiList}
                                        //                        value={this.state.dtoData.idsubareafrascati}
                                        //                        onChange={this.handleSelectChange}
                                        //                        placeholder=""
                                        //                        name="idsubareafrascati"
                                        //                        id="idsubareafrascati"
                                        //                        icon="fa-caret-right"
                                        //                        tipo=""
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //            </FormGroup>
                                        //        </Col>


                                        //    </Row>
                                        //    <Row form>
                                        //        <Col md={6}>
                                        //            <p style={{ color: "#FFC200" }}>2DA ÁREA DE CONOCIMIENTO CINE</p>
                                        //            <FormGroup row>
                                        //                <Col md={4} className="">
                                        //                    <Label for="idpais">Área de conocimiento <br /> CINE en función del título</Label>
                                        //                    <SelectItem
                                        //                        options={areaCINEList2}
                                        //                        value={this.state.dtoData.strCampoamplio2}
                                        //                        onChange={this.cargarSubAreaCINE}
                                        //                        placeholder=""
                                        //                        name="strCampoamplio2"
                                        //                        id="strCampoamplio2"
                                        //                        icon="fa-caret-right"
                                        //                        tipo="2"
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={4} className="">
                                        //                    <Label for="strCampoespecifico">Sub-Área de  <br /> conocimiento CINE</Label>
                                        //                    <SelectItem
                                        //                        options={subAreaCINEList2}
                                        //                        value={this.state.dtoData.strCampoespecifico2}
                                        //                        onChange={this.cargarMaterias}
                                        //                        placeholder=""
                                        //                        name="strCampoespecifico2"
                                        //                        id="strCampoespecifico2"
                                        //                        icon="fa-caret-right"
                                        //                        tipo="2"
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={4} className="">
                                        //                    <Label for="strCampodetallado">Área de conocimiento <br /> (materias)</Label>
                                        //                    <SelectItem
                                        //                        options={materiaCINEList2}
                                        //                        value={this.state.dtoData.idnomenclaturatit2}
                                        //                        onChange={this.handleSelectChange}
                                        //                        placeholder=""
                                        //                        name="idnomenclaturatit2"
                                        //                        id="strCampodetallado2"
                                        //                        icon="fa-caret-right"
                                        //                        tipo="2"
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //            </FormGroup>

                                        //        </Col>

                                        //        <Col md={6}>
                                        //            <p style={{ color: "#FFC200" }}>2DA ÁREA DE CONOCIMIENTO FRASCATI</p>
                                        //            <FormGroup row>
                                        //                <Col md={6} className="">
                                        //                    <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título</Label>
                                        //                    <SelectItem
                                        //                        options={areaFrascatiList2}
                                        //                        value={this.state.dtoData.idareafrascati2}
                                        //                        onChange={this.cargarSubAreaFrascati}
                                        //                        placeholder=""
                                        //                        name="idareafrascati2"
                                        //                        id="idareafrascati2"
                                        //                        icon="fa-caret-right"
                                        //                        tipo="2"
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //                <Col md={6} className="">
                                        //                    <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI</Label>
                                        //                    <SelectItem
                                        //                        options={subAreaFrascatiList2}
                                        //                        value={this.state.dtoData.idsubareafrascati2}
                                        //                        onChange={this.handleSelectChange}
                                        //                        placeholder=""
                                        //                        name="idsubareafrascati2"
                                        //                        id="idsubareafrascati2"
                                        //                        icon="fa-caret-right"
                                        //                        tipo="2"
                                        //                        disabled={true}
                                        //                    />
                                        //                </Col>
                                        //            </FormGroup>
                                        //        </Col>


                                        //    </Row>

                                        //</form >
                                    }


                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {ExperienciaProyectosDataList.map((dto, index) =>
                                                <CardExperienciaProyectos
                                                    key={dto.idproyectoinvestigacion}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + ExperienciaProyectosDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.tabla, dto.idproyectoinvestigacion, dto.idpersona)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default ExperienciaProyectos;